import React from "react";
import { motion } from "framer-motion";
import course_syllabus from "../assets/documents/procedures/JujutsuCourseSyllabus_fall_2009.pdf";
import { Button } from "reactstrap";
import "../assets/css/aboutPage.css";
const UconnAboutPage = () => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={{
        hidden: {
          scale: 0.8,
          opacity: 0,
        },
        visible: {
          scale: 1,
          opacity: 1,
          transition: {
            delay: 0.4,
          },
        },
      }}
    >
      <div className="bod">
        <main className="col-xs-12 col-lg-10">
          <div id="skillsAbout">
            <h3>ABOUT </h3>
            <div id="about_border">
              <div id="bio">
                <h1>Wa Shin Ryu </h1>
                <img
                  alt={"Throw"}
                  src={require("../assets/img/contextPics/Throw1.jpg")}
                  className="image-wrapper float-left img-responsive pr-2"
                  id="aboutImage"
                />

                <article className="pull-right">
                  Dr. Yiannakis started the UConn Judo Club in 1976 but the name
                  was changed to UConn Judo and Jujutsu Club in 1995, and then
                  finally to UConn Jujutsu Club in 1999. The official Japanese
                  name for the club is BUDENKAN, the school of traditional
                  martial arts. The club is the home of
                  <b> Wa Shin Ryu Jujutsu</b>, a holistic, comprehensive system
                  of unarmed combat founded by Prof. Yiannakis in 1983. The
                  system has a basis, in form and philosophy, in Koryu Bujutsu
                  (classical martial arts) but as an evolved system it may be
                  best described as
                  <b>a modern martial art with classical moorings</b>. Unlike
                  most classical, or classically based systems, however, the art
                  stresses the development of effective combative skills by
                  training students in live sparring situations in distance,
                  close quarter and ground fighting contexts. Such forms of
                  training develop sustained focused concentration, hand-leg-eye
                  coordination, and create for students a high degree of realism
                  that set routines and repetition training alone cannot
                  provide. However, the purpose of such intensive training is
                  not to make us violent. The goal is to empower us so that we
                  can walk away with confidence, if that is deemed the
                  appropriate response at the time!
                  <br />
                  <br />
                  An effective martial artist is an empowered individual. And
                  empowered individuals have the confidence to make choices and
                  decide whether to engage in violence, or to contain/defuse a
                  situation by other means. Thus, in the modern world an
                  empowered martial artist is a type of person who, by having
                  many options can make the choice to avoid/prevent violence, or
                  when the situation demands can save himself/herself and
                  others. The unempowered individual has no such options or
                  choices!
                  <br />
                  <br />
                  In developing the system the Founder integrated the traditions
                  of the old, with the best of the new, to form a budo system
                  that serves: (1) <b>As a personal discipline, </b>(2){" "}
                  <b>As a way of life, and,</b> (3) As a path to self
                  actualization in the physical, psychological and
                  <b>spiritual domains </b>(the ultimate goal of the system).
                  <br />
                  <br />
                  The club includes both male and female students and community
                  participation is encouraged. There is a minimal fee for club
                  membership per semester, but is free to occasional guests and
                  other visitors.{" "}
                  <div>
                    To earn 1 credit for Jujutsu at the University of
                    Connecticut (As AH1200-03), a permission number is required.
                    Contact Sensei Kane if you wish to do so.
                  </div>
                  <div>
                    NOTE: We put on demonstrations and give clinics and
                    workshops for law enforcement, the military and security
                    agencies. If interested, leave a message on our{" "}
                    <Button id="contactButtonAboutPage" href={"#/contact"}>
                      CONTACT{" "}
                    </Button>{" "}
                    page.
                  </div>
                  <div id="classInactive">
                    Class and club are currently inactive. This is due to the University
                    of Connecticut's classes reduction caused by budget cuts.
                    Please reach out for more information/updates!
                  </div>
                </article>

                <Button
                  id="purple"
                  href={course_syllabus}
                  download="JujutsuCourseSyllabus_fall_2021.pdf"
                >
                  Course SYLLABUS
                </Button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </motion.div>
  );
};

export default UconnAboutPage;
